



import React from "react";
import "./Delivered_order.css";
import Common_Back_Header from "../../../../../Common-Component/common_back_header/Common_Back_Header";
import Order_id_holder from "../order_details/order_id_holder/Order_id_holder";
import Order_details_table from "../order_details/order_details_table/Order_details_table";
import Rating_Review from "../order_details/rating_review/Rating_Review";
import Receiver_info_holder from "../order_details/receiver_info_holder/Receiver_info_holder";
import Payment_Summary from "../order_details/payment_summary/Payment_Summary";


function Delivered_order() {
    const breadcrumbs = [
        { label: "Home", link: "/", isActive: false },
        { label: "MY ORDERS", link: "/account", isActive: false },
        { label: "DELIVERED ORDER", link: "", isActive: true },
    ];
    return (
        <>
            <section className="Delivered_order Order_details">


                <div className="container">

                    <Common_Back_Header backNavigation="/my-orders" showReOrder/>

                    <div className="row">
                        <div className=" col-lg-8 col-md-7">
                            <Order_id_holder headingText="Order ID #859865" subText="Delivered"/>

                            <Order_details_table />

                            <Rating_Review />

                        </div>
                        <div className="col-lg-4 col-md-5">
                            <Receiver_info_holder />
                            <Payment_Summary />
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Delivered_order;
